import { __,_x } from '@wordpress/i18n';
import {PanelBody, RangeControl} from '@wordpress/components';
import IconPicker from '@vayu-blocks/iconPicker/iconpicker.js';
import {VayuBlocksTextControl, HeightControl, VayuBlocksToggleControl, 
	VayuBlocksSelectControl} from '@vayu-blocks';
import { SlideButton } from '@vayu-blocks/global';

const UnfoldSettingPanel = ({attributes,setAttributes, openPanels, onTogglePanel}) => {
	
    return (
        <>
        	<PanelBody title={ __( 'Settings', 'vayu-blocks' ) } className="th-adv-blurb-setting-panel" opened={openPanels['settings-settings']} onToggle={() => onTogglePanel('settings-settings')} >

				<SlideButton  
					button={{ fold: "Fold", unfold: "Unfold" }}
					onChange={(value) => setAttributes({foldicon:value})} 
					defaultValue={attributes.foldicon}
				/> 
  
				{attributes.foldicon === 'fold' ? (
					<div className="vb-toggle-unfold-wrap">
						<VayuBlocksTextControl
							label={__('Button Text', 'vayu-blocks')}
							value={attributes.foldBtnTxt || ''}
							onChange={(value) => setAttributes({ foldBtnTxt: value })}
						/>

						<IconPicker
							Icon={attributes.selectedFoldIcon}
							onIconSelect={(icon) => {
								setAttributes({ selectedFoldIcon: icon }); // Ensure this updates fold icon only
							}}
						/>
					</div>
				) : attributes.foldicon === 'unfold' ? (
					<div className="vb-toggle-unfold-wrap">
						<VayuBlocksTextControl
							label={__('Button Text', 'vayu-blocks')}
							value={attributes.unfoldBtnTxt || ''}
							onChange={(value) => setAttributes({ unfoldBtnTxt: value })}
						/>

						<IconPicker
							Icon={attributes.selectedUnFoldIcon}
							onIconSelect={(icon) => {
								setAttributes({ selectedUnFoldIcon: icon });
							}}
						/>
					</div>
				) : null}
			
        	</PanelBody>
			
			<PanelBody title={ __( 'Content option', 'vayu-blocks' ) } className="th-adv-blurb-content-panel" opened={openPanels['settings-option']} onToggle={() => onTogglePanel('settings-option')} >

				<HeightControl 
					label={__('fold Height', 'vayu-blocks')}
					value={ attributes.contentheight }
					onChange={ (value)=>setAttributes({contentheight:value}) }
					responsive={true}
					unitMax={{px: { max: 1000, step: 1 }}}
					customUnits={['px','vh', 'vw', 'em', 'rem']}
				/>

				<br/>

				<VayuBlocksSelectControl
					label={__('Show Event', 'vayu-blocks')}
					value={attributes.contentShowEvent}
					options={[
						{ label: __('on button click', 'vayu-blocks'), value: 'buttonclick' },
						{ label: __('on content click', 'vayu-blocks'), value: 'contentclick' },
						{ label: __('on content hover', 'vayu-blocks'), value: 'contenthover' },
					]}
					onChange={(e) => setAttributes({ contentShowEvent: e })}
				/>

				{(attributes.contentShowEvent === 'contentclick' || attributes.contentShowEvent === 'contenthover') && (
					<VayuBlocksToggleControl
						label={__('Hide On Button', 'vayu-blocks')}
						checked={attributes.hideUnfoldButton}
						onChange={(hideUnfoldButton) => setAttributes({ hideUnfoldButton })}
					/>
				)}

			</PanelBody>

			<PanelBody title={ __( 'Fold Transition', 'vayu-blocks' ) } className="th-adv-blurb-content-panel" opened={openPanels['settings-transition']} onToggle={() => onTogglePanel('settings-transition')}> 

				<VayuBlocksToggleControl
					label={__('Transition', 'vayu-blocks')}
					checked={attributes.trans}
					onChange={(value) => setAttributes({ trans: value })}
				/>

				{attributes.trans && (
					<>
						<RangeControl
							label={__('Transition Duration', 'vayu-blocks')}
							value={attributes.transition}
							onChange={(value) => setAttributes({transition: value})}
							step={0.1}
							min={0}
							max={3}
							allowReset={true}
						/>

						<VayuBlocksSelectControl
							label={__('Transition Function', 'vayu-blocks')}
							value={attributes.foldTrans}
							options={[
								{ label: 'Ease', value: 'ease' },
								{ label: 'Ease-Out', value: 'ease-out' },
								{ label: 'Ease-In-Out', value: 'ease-in-out' },
								{ label: 'Fold Fast (Snap In)', value: 'cubic-bezier(0.8, 0, 1, 1)' },
								{ label: 'Fold Slow (Ease In)', value: 'cubic-bezier(0.0, 0, 0.2, 1)' },
								{ label: 'Back In-Out (Same)', value: 'cubic-bezier(0.68, -0.55, 0.27, 1.55)' },
								{ label: 'Sine In-Out (Same)', value: 'cubic-bezier(0.45, 0.05, 0.55, 0.95)' },
								{ label: 'Inverted Bezier', value: 'cubic-bezier(0.1, 1.5, 0.8, -0.5)' },
							]}

							onChange={(value) => setAttributes({foldTrans: value})}
						/>
					</>  
				)}

			</PanelBody>
        </>
    )

}
export default UnfoldSettingPanel;